<template>
  <div class="bb-fatigue-levels-hover">
    <button
      type="button"
      class="btn btn-lg btn-primary bb-fatigue-levels-button"
    >
      Fatigue Levels
    </button>
    <div class="card bb-card bb-fatigue-levels-popup rounded">
      <div class="container-fluid p-3 bb-tooltip-wrapper">
        <div class="bb-hdg mb-3 text-center">Fatigue Levels</div>
        <div class="table-responsive bb-fatigue-levels-table-wrap">
          <table
            class="table table-sm table-dark table-striped mb-0 bb-fatigue-levels-table"
          >
            <thead>
              <tr>
                <th>Fatigue Level</th>
                <th>CON Threshold</th>
                <th>Skills Adj</th>
                <th>Move Adj</th>
                <th>SR Adj</th>
                <th>Dex Adj</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in fatigueLevelRows"
                :key="row.level"
              >
                <td>{{ row.level }}</td>
                <td>{{ row.conThreshold }}</td>
                <td>{{ row.skillsAdj }}</td>
                <td>{{ row.moveAdj }}</td>
                <td>{{ row.srAdj }}</td>
                <td>{{ row.dexAdj }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FatigueLevelsPopup',
  props: {
    baseCon: {
      type: Number,
      required: true,
    },
  },
  computed: {
    fatigueLevelRows() {
      const buildRow = ({
        level,
        fatiguePercent,
        skillsAdj,
        moveAdj,
        srAdj,
        dexAdj,
      }) => {
        const threshold = Math.floor(this.baseCon * fatiguePercent)
        return {
          level,
          conThreshold: threshold,
          skillsAdj,
          moveAdj,
          srAdj,
          dexAdj,
        }
      }

      return [
        buildRow({
          level: 'Winded',
          fatiguePercent: 0.8,
          skillsAdj: '-10%',
          moveAdj: '0',
          srAdj: '0',
          dexAdj: '0',
        }),
        buildRow({
          level: 'Tired',
          fatiguePercent: 0.6,
          skillsAdj: '-20%',
          moveAdj: '-1m',
          srAdj: '0',
          dexAdj: '0',
        }),
        buildRow({
          level: 'Wearied',
          fatiguePercent: 0.4,
          skillsAdj: '-30%',
          moveAdj: '-1m',
          srAdj: '-2',
          dexAdj: '0',
        }),
        buildRow({
          level: 'Exhausted',
          fatiguePercent: 0.2,
          skillsAdj: '-40%',
          moveAdj: 'Half Mvt',
          srAdj: '-4',
          dexAdj: '-5',
        }),
        buildRow({
          level: 'Debilitated',
          fatiguePercent: 0.1,
          skillsAdj: '-50%',
          moveAdj: 'Half Mvt',
          srAdj: '-6',
          dexAdj: '-10',
        }),
      ]
    },
  },
}
</script>

<style scoped>
.bb-fatigue-levels-hover {
  position: relative;
  z-index: 40;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  transform: translate(-6.4rem, 5.1rem);
}

.bb-fatigue-levels-button {
  min-width: 12.5rem;
  padding: 0.65rem 1.2rem;
  font-size: 1.05rem;
  line-height: 1.1;
  white-space: nowrap;
}

.bb-fatigue-levels-popup {
  position: absolute;
  top: calc(100% + 0.6rem);
  right: 0;
  display: none;
  width: min(54rem, 90vw);
  max-height: 32rem;
  overflow: auto;
  background: #2d3338;
  box-shadow: 0 1.35rem 2.8rem rgba(0, 0, 0, 0.48);
}

.bb-fatigue-levels-hover:hover .bb-fatigue-levels-popup,
.bb-fatigue-levels-hover:focus-within .bb-fatigue-levels-popup {
  display: block;
}

.bb-fatigue-levels-table-wrap {
  overflow-x: auto;
}

.bb-fatigue-levels-table {
  color: #f1f3f5;
  font-size: 1.24rem;
}

.bb-fatigue-levels-table th,
.bb-fatigue-levels-table td {
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;
  padding: 0.7rem 0.6rem;
}

.bb-fatigue-levels-table th:first-child,
.bb-fatigue-levels-table td:first-child {
  text-align: left;
}

@media (max-width: 1200px) {
  .bb-fatigue-levels-hover {
    transform: translate(-1.9rem, 5.1rem);
  }

  .bb-fatigue-levels-popup {
    right: -1rem;
  }
}
</style>
